<template>
  <v-card>
    <v-card-title>
      <span class="headline">Edit Username</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field type="name" color="#4dbac0" label="Username" v-model="username"></v-text-field>
          <div class="errors">
                <li v-for="(error, index) in errors" :key="index">{{error}}</li>
              </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {
      name: "editUsername",
      username: this.$store.getters.username,
      errors: new Array()
    };
  },
  methods: {
    close() {
      this.$emit("close", this.name);
      this.username = this.$store.getters.username
    },
    save() {

      this.errors = [];


      // length check
      if(this.username.length < 2)
        this.errors.push("Username length have to be 2-15")
      if(this.username.length > 15)  
        this.errors.push("Username length have to be 2-15")

      // accptable characters
      var usernameRegex = /^[a-zA-Z0-9]+$/;
      var validUsername = this.username.match(usernameRegex);
      if(validUsername == null){
        this.errors.push("Only characters A-Z, a-z and 0-9 are acceptable.")
      }

      if (this.errors.length == 0 && this.username != this.$store.getters.username) {
      this.$store.dispatch("updateUsername", {
          type: "username",
          name: "username",
          value: this.username
        })
        .then(() => {
          this.$emit("close", this.name);
          this.username = this.$store.getters.username
        })
        .catch(() => {
          this.errors.push("User name already taken")
        });
      }

      
    }
  }
};
</script>

<style scoped>
.headline {
  color: #4dbac0;
}
</style>